/**
 * 优先原生 Web Speech API（直接指定 ja-JP 语系），
 * 移动端自动调用底层日语合成器，不去校验 getVoices() 避免异步误判。
 */
export const playAudio = (text: string) => {
  if (!text) return

  // 优先：原生语音（纯本地，零网络）
  if (typeof window !== 'undefined' && window.speechSynthesis) {
    try {
      window.speechSynthesis.cancel()

      const cleanedText = text.replace(/[。，、？！]/g, ' ').trim()
      const utterance = new SpeechSynthesisUtterance(cleanedText)

      utterance.lang = 'ja-JP'
      utterance.rate = 0.85

      window.speechSynthesis.speak(utterance)
      console.log('[TTS] 成功强开系统原生底层的日语发音芯片:', cleanedText)
      return
    } catch (nativeErr) {
      console.warn('[TTS] 原生语音尝试失败，尝试网络兜底...', nativeErr)
    }
  }

  // 兜底：极端老旧设备走有道网络请求
  try {
    const cleanedText = text.replace(/[。，、？！]/g, ' ').trim()
    const url = `https://dict.youdao.com/dictvoice?audio=${encodeURIComponent(cleanedText)}&le=jap`

    let audioEl = document.getElementById('jp-tts-audio') as HTMLAudioElement
    if (!audioEl) {
      audioEl = document.createElement('audio')
      audioEl.id = 'jp-tts-audio'
      audioEl.style.display = 'none'
      document.body.appendChild(audioEl)
    }

    audioEl.removeAttribute('referrerpolicy')
    audioEl.src = url
    audioEl.play().catch((e) => console.warn('[TTS] 网络兜底也被拦截:', e.message))
  } catch (e) {
    console.warn('[TTS] 顶级音频轨异常:', e)
  }
}
